const trtc = r => require.ensure([], () => r(require('@/page/trtc')), 'trtc');
export default [
  {
    path: '/trtc',
    name: 'trtc',
    component: trtc
  }
];



// WEBPACK FOOTER //
// ./src/router/trtc.js